import { Claim, User, UserDTO, CLAIM_TYPE, USER_ROLES } from './authApi.constants';
import { authFetch } from 'auth/utils';
import { envVariables } from 'src/common/utils/envVariables';

const getAuthPath = () => {
  if (globalThis.location.href.includes('provisioning-requests')) {
    return envVariables.VITE_BULK_PROVISIONING_AUTH_API;
  }

  if (globalThis.location.href.includes('audit-trail')) {
    return envVariables.VITE_AUDIT_TRAIL_AUTH_API;
  }

  return envVariables.VITE_SIM_INVENTORY_AUTH_API;
};

export const loginRedirect = async () => {
  const urlQuery = new URLSearchParams({
    returnUrl: globalThis.location.href,
  });

  const authPath = getAuthPath();

  globalThis.location.href = `${authPath}/auth/login?` + urlQuery.toString();
};

export const logoutRedirect = async () => {
  const urlQuery = new URLSearchParams({
    returnUrl: globalThis.location.origin,
  });

  const authPath = getAuthPath();

  globalThis.location.href = `${authPath}/auth/logout?` + urlQuery.toString();
};

export const fetchUser = async () => {
  const getUserFromClaims = (claims: Claim[]) => {
    const user = claims.reduce((user, claim) => {
      if (claim.type === CLAIM_TYPE.GivenName) {
        return { ...user, givenName: claim.value };
      }

      if (claim.type === CLAIM_TYPE.Surname) {
        return { ...user, surname: claim.value };
      }

      if (claim.type === CLAIM_TYPE.EmailAddress) {
        return { ...user, emailAddress: claim.value };
      }

      if (claim.type === CLAIM_TYPE.PreferredUsername) {
        return { ...user, username: claim.value };
      }

      if (claim.type === CLAIM_TYPE.Role && USER_ROLES.includes(claim.value)) {
        return { ...user, role: claim.value };
      }

      if (claim.type === CLAIM_TYPE.AccountReferenceId) {
        return { ...user, referenceId: claim.value };
      }

      if (claim.type === CLAIM_TYPE.AccountType) {
        return { ...user, accountType: claim.value };
      }

      return user;
    }, {});

    return user as User;
  };

  const authPath = getAuthPath();

  const response = await authFetch(`${authPath}/auth/user`);

  if (!response.ok) {
    throw new Error(response.status.toString());
  }

  const data: UserDTO = await response.json();

  return getUserFromClaims(data.claims);
};

export const fetchAccount = async (referenceId: string) => {
  const response = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_AUTH_API}/accounts/${referenceId}`,
  );

  const account: { accountName: string; accountRef: string } = await response.json();
  return account;
};
